import { render, staticRenderFns } from "./RootEl.vue?vue&type=template&id=06c46bfc&"
import script from "./RootEl.ts?vue&type=script&lang=ts&"
export * from "./RootEl.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RootEl.vue"
export default component.exports